import React from 'react'
import { useAuth } from '../../Context/ContextProvider'
import { Link } from 'react-router-dom'

function RecentNews({ latestNews }) {
  const { image_url } = useAuth()


  const dateFormate = (date) => {
    const newDate = new Date(date)
    const options = { year: 'numeric', month: 'short', day: 'numeric' }
    const formattedDate = newDate.toLocaleDateString('en-UK', options)
    return formattedDate
  }
  return (
    <section className="blog-area blog-home-area">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title text-center">
              <h3 className="home_page_section_title mb-4">Recent News Articles</h3>

            </div>
          </div>
        </div>
        <div className="row post-home-style row-gutter-40">
          {latestNews?.slice(0, 3)?.map((item, idx) => {
            return (
              <div className="col-md-6 col-lg-4">
                {/*== Start Blog Post Item ==*/}
                <Link to={`/news-detail/${item?._id}`}>
                  <div className="post-item">
                    <div className={`thumb ${idx % 2 === 0 ? "mb--0" : ""}`}>
                      <img style={{ objectFit: "cover" }} src={item?.image} alt="Image" width={370} height={idx % 2 === 0 ? 270 : 340} />
                    </div>
                    <div className="content">
                      <div className="author">By Admin</div>
                      <h4 className="title">{item?.title}</h4>
                      <div className="meta">
                        <span className="post-date">{dateFormate(item?.createdAt)}</span>
                        <span className="dots" />
                        <span className="post-time">10 min read</span>
                      </div>
                    </div>
                  </div>
                </Link>
                {/*== End Blog Post Item ==*/}
              </div>
            )
          })}
        </div>
        <div className='text-center mt-5'>
          <Link to="/latest-news">
            <button className='btn-theme-news'>View All</button>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default RecentNews